export const EXPERIMENT_USA_UNLIMITED_OFFER = 'usa-unlimited-offer';
export const EXPERIMENT_USA_UNLIMITED_OFFER_VARIANT_CONTROL = 'control';
export const EXPERIMENT_USA_UNLIMITED_OFFER_VARIANT_UNLIMITED_ONLY =
  'unlim-only';
export const EXPERIMENT_USA_UNLIMITED_OFFER_VARIANT_UNLIMITED_PLUS =
  'unlim-19-plus-12';
export const EXPERIMENT_LOCKDOWN_RECIPIENT = 'lockdown-recipient';
export const FF_ADSERVER_MIGRATION = 'openx-ad-server-migration';
export const EXPERIMENT_UPSELL_SURVEY = 'upsell_survey';
export const EXPERIMENT_INBOX = 'inbox-received-transfers';
export const EXPERIMENT_SELF_SENDER_TOOLTIP = 'self-sender-tooltip';
export const EXPERIMENT_SEND_FEEDBACK = 'send-feedback';
